export default __webpack_public_path__ + "static/media/play-video-icon.76a8a0d7.svg";